import * as Adaptive from 'adaptivecards';

export default class CustomHttpAction extends Adaptive.HttpAction {
    private preserveBody: boolean;
    // The originalJsonPayload is only used for MessageCard (not adaptive cards), so this value is populatedin the parseHttpAction function
    public originalJsonPayload?: any;
    public hideCardOnInvoke: boolean;

    /// Custom HttpAction used by MessageCards have preserveBody = true.
    /// Existing message cards don't expect to have the content of the body changed, so undo the work
    /// that prepare does on the message body so that it preserves the placeholders that the server expects
    constructor(preserveBody: boolean) {
        super();

        this.preserveBody = preserveBody;
    }

    internalPrepareForExecution(inputs: Adaptive.Dictionary<Adaptive.Input>) {
        const originalBody = this.body;
        super.internalPrepareForExecution(inputs);

        if (this.preserveBody) {
            this.body = originalBody;
        }
    }

    parse(json: any): void {
        super.parse(json);
        this.isPrimary = json.isPrimary;
    }
}
